import React, {useContext} from 'react';
import {LocalStorage} from '../../../utils/hooks/useLocalStorage';
import {
  DropSubscribeModalData,
  DropsSubscriptionSchema,
  DropsSubscriptions,
  IsSubscribedEmailType,
} from '../types';
import {DROPS_SUBSCRIBED_STORAGE_KEY} from '../utils/constants';

const DEFAULT_DROPS_SUBSCRIPTIONS: Record<
  'guest' | 'ayUser',
  IsSubscribedEmailType
> = {
  guest: {
    allDrops: {
      isSubscribed: false,
      subscribedTypes: [],
    },
    individualDrops: {},
    email: '',
  },
  ayUser: {
    allDrops: {
      isSubscribed: false,
      subscribedTypes: [],
    },
    individualDrops: {},
    email: '',
  },
};

class DropsSubscriptionStorage {
  private _guest: IsSubscribedEmailType | undefined;
  private _ayUser: IsSubscribedEmailType | undefined;
  private _modalData: DropSubscribeModalData;
  private _localStorage: LocalStorage<DropsSubscriptionSchema> =
    new LocalStorage<DropsSubscriptionSchema>(
      DROPS_SUBSCRIBED_STORAGE_KEY,
      () => ({...DEFAULT_DROPS_SUBSCRIPTIONS}),
      true,
    );

  constructor() {
    const defaultStoredSubscriptionData = this._localStorage.getItem();

    if (defaultStoredSubscriptionData.guest) {
      if (
        defaultStoredSubscriptionData.guest.individualDrops ||
        defaultStoredSubscriptionData.guest.allDrops
      ) {
        this._guest = defaultStoredSubscriptionData.guest;
      }
    }

    if (defaultStoredSubscriptionData.ayUser) {
      if (
        defaultStoredSubscriptionData.ayUser.individualDrops ||
        defaultStoredSubscriptionData.ayUser.allDrops
      ) {
        this._ayUser = defaultStoredSubscriptionData.ayUser;
      }
    }

    this._modalData = {
      backgroundImageUrl: '',
      headline: '',
      subline: '',
      isOpen: false,
      allDropsSubscriptionStatus: false,
      currentDrop: false,
    };
  }

  get guest() {
    return this._guest;
  }

  get ayUser() {
    return this._ayUser;
  }

  get modalData() {
    return this._modalData;
  }

  setModalData(modalData: DropSubscribeModalData) {
    this._modalData = {
      ...this._modalData,
      ...modalData,
    };
  }

  setSubscriptions(subscriptions: DropsSubscriptionSchema) {
    if (subscriptions.guest) {
      this._guest = subscriptions.guest;
    }
    if (subscriptions.ayUser) {
      this._ayUser = subscriptions.ayUser;
    }

    if (subscriptions.guest || subscriptions.ayUser) {
      this._localStorage.setItem({
        ayUser: this._ayUser,
        guest: this._guest,
      });
    }
  }
}

export const DROPS_SUBSCRIPTION_STORAGE = new DropsSubscriptionStorage();

export const DropsSubscriptionsContext =
  React.createContext<DropsSubscriptions>(DROPS_SUBSCRIPTION_STORAGE);

export const useDropsSubscriptionsContext = () =>
  useContext(DropsSubscriptionsContext);
